import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from './pages/Login/Login';
import Register from './pages/Login/Register';
import UserTests from './pages/UserTests/UserTests';
import Test from './pages/Test/Test';
import Results from './pages/Results/Results';
import ForgotPassword from './pages/Login/ForgotPassword';
import ResetPasswordForm from './pages/Login/ResetPasswordForm';
import { Provider } from 'react-redux';
import store from './store';
import PrivateRoute from './components/PrivateRoute';
import Landing from './pages/Landing/Landing';
import Contact from './pages/Contact/Contact';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminMessages from './pages/Admin/AdminMessages';
import AdminRoute from './components/AdminRoute';
import AdminDashboard from './pages/Admin/AdminDashboard';
import Profile from './pages/Profile';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/admin" component={AdminLogin} />
          <Route exact path="/admin/messages" component={AdminMessages} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/reset-password/:token" component={ResetPasswordForm} />
          <AdminRoute exact path="/admin/dashboard" component={AdminDashboard} />
          <PrivateRoute exact path="/usertests" component={UserTests} />
          <PrivateRoute exact path="/test" component={Test} />
          <PrivateRoute exact path="/results" component={Results} />
          <PrivateRoute exact path="/profile" component={Profile} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
